import { useContext, useCallback } from 'react';
import { AjaxContext } from 'commons-ui';
import { IMagicBoxSchedule } from '../model';

const useService = () => {
	const { postData } = useContext(AjaxContext);

	const requestCreateMagicBoxSchedule = useCallback((appName: string, magicBoxSchedule: IMagicBoxSchedule) => {
		return postData({
			endpoint: '/marketing/dashboard/magicBox/createSchedule',
			body: { magicBoxSchedule },
			queryParams: { appName }
		});
	}, []);

	const requestRemoveMagicBoxSchedule = useCallback((appName: string, scheduleId: string) => {
		return postData({
			endpoint: '/marketing/dashboard/magicBox/removeSchedule',
			body: { scheduleId },
			queryParams: { appName }
		});
	}, []);

	return {
		requestCreateMagicBoxSchedule,
		requestRemoveMagicBoxSchedule
	};
};

export default useService;
